import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Service } from '@angular/core';

import { API_URL } from '@constants';
import { Comment } from '@models';
import { ModalService } from '@services';

@Service()
export class CommentService {
  modalService = inject(ModalService);
  http = inject(HttpClient);

  deleteCommentHttp = (commentId: number) =>
    this.http.delete(`${API_URL}/comments/${commentId}`);

  getFileComments = (
    rid: number,
    params?: HttpParams | Record<string, string | number>
  ) => this.http.get<Comment[]>(`${API_URL}/files/${rid}/comments`, { params });

  addFileComment = (
    rid: number,
    data: { text: string; replyTo?: number | string }
  ) => this.http.post<Comment>(`${API_URL}/files/${rid}/comments`, data);

  deleteComment = (commentId: number) =>
    this.modalService.openConfirmation({
      title: 'WEB_DIALOGS_COMMENT_DELETE',
      text: 'WEB_DIALOGS_CONFIRM',
      confirmLabel: 'WEB_ACTIONS_DELETE',
      danger: true,
      successText: 'WEB_NOTIFY_COMMENT_DELETE_SUCCESS',
      action: () => this.deleteCommentHttp(commentId),
      result: commentId,
    });

  deleteMessage = (messageId: number) =>
    this.modalService.openConfirmation({
      title: 'WEB_DIALOGS_CONVERSATIONS_MESSAGE_DELETE',
      text: 'WEB_DIALOGS_CONFIRM',
      confirmLabel: 'WEB_ACTIONS_DELETE',
      danger: true,
      successText: 'WEB_NOTIFY_CONVERSATION_DELETE_MESSAGE_SUCCESS',
      action: () => this.deleteCommentHttp(messageId),
      result: messageId,
    });
}
